import { combineReducers } from "@reduxjs/toolkit";
import DownloadCustomer from "./dowloadCustomers/dataSlice";
import CustomerById from "./loadCustomerById/dataSlice";
import Customers from "./loadCustomers/dataSlice";
import CustomersWhereCompany from "./loadCustomersWhereCompany/dataSlice";
import ResetPassword from "./resetPassword/dataSlice";
import CustomerUpdate from "./updateCustomer/dataSlice";

const reducer = combineReducers({
  allCustomers: Customers,
  customerById: CustomerById,
  update: CustomerUpdate,
  allCustomersWhereCompany: CustomersWhereCompany,
  resetPassword: ResetPassword,
  download: DownloadCustomer,
});

export default reducer;
